import http from '../utils/http-common';
import { StatsResponse } from '../types/common.types';
import { StatsInput, UserChatDataResponse, UserChatListInput, UserChatsDataResponse, UserChatsList, UserListInput, UserListResponse } from '../types/user.types';

const getDashboardStats = (input: StatsInput) => {
  return http.post<StatsResponse>('/admin/user-data/get-stats', input);
};

const getAppUsers = (data: UserListInput) => {
  return http.post<UserListResponse>('/admin/user-data/user-list', data);
};

const getUserChatData = (data: UserChatListInput) => {
  return http.post<UserChatDataResponse>('/admin/user-data/user-chat-data', data);
};

const downloadUserChatData = (data: UserChatsList) => {
  return http.post<UserChatsDataResponse>('/admin/user-data/all-user-chat-data', data);
};

const UserDataService = {
  getDashboardStats,
  getAppUsers,
  getUserChatData,
  downloadUserChatData
};

export default UserDataService;
